import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import type React from 'react';
import priceFormat from 'services/format/priceFormat';
import { NAVY, RADIUS_ITEM } from 'styles/tokens';

interface EditableAttributeProps {
  label: string;
  value: string | boolean | number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled: boolean;
  type: 'text' | 'price' | 'number' | 'email' | 'checkbox';
}

const EditableAttribute = ({ label, value, onChange, disabled, type }: EditableAttributeProps) => (
  <Grid
    size={12}
    sx={{
      py: disabled ? 0 : 1,
    }}
  >
    {disabled && (
      <span style={{ color: NAVY }}>
        <b>{label}:</b> {type === 'price' && priceFormat.format(Number(value))}
        {type === 'number' && Number(value)}
        {type === 'checkbox' && (value === true ? 'Si' : value || 'No')}
        {type !== 'price' && type !== 'number' && type !== 'checkbox' && value}
      </span>
    )}
    {!disabled && type !== 'checkbox' && (
      <TextField
        label={label}
        value={value}
        onChange={onChange}
        type={type}
        fullWidth
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: RADIUS_ITEM,
            color: NAVY,
          },
        }}
      />
    )}
    {!disabled && type === 'checkbox' && (
      <span style={{ color: NAVY }}>
        <b>{label}:</b>
        <input type="checkbox" checked={!!value} onChange={onChange} />
      </span>
    )}
  </Grid>
);

export default EditableAttribute;
